<template>
  <div class="comme">
    <div class="comme_radio_list" >
      <div v-for="(item,index) in info.options"  :key="index">
      <div
        v-if="item.optionId"
        class="radio_list_item"
        :class="{radio_list_item__active: activeId == item.optionId|| valueId == item.optionId}"
        @click="changeCheckActive(item.optionId,item)"
       
      >
        <el-tooltip  effect="light" :content="item.optionExplain" placement="top-start">
            <span v-if="item.optionExplain && item.optionExplain != ''">{{ item.optionName }}</span>
        </el-tooltip>
        <span v-if="item.optionExplain == '' || !item.optionExplain">{{ item.optionName }}</span>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeId: null
    };
  },
    props: {
      info: {
          type: [Object,Array],
          default: ()=> {}
      },
      index: {
          type: [String,Number],
          default: null
      },
      valueId: {
        type: [String,Number,Array],
        default: null
      }
  },
  mounted() {
		this.$nextTick(()=>{
			this.activeId = this.info.optionId
		})
	},
  methods: {
    // 切换选择框状态
    changeCheckActive(id, item) {
      this.activeId = id;
      let obj = {
        index: this.index,
        fieIdValue: item.optionName,
        optionId: [item.optionId],
        fieIdId: this.info.fieIdId,
        options: this.info.options,
        value: item.unitPrice
      };
      this.$emit("changebox", obj);
    }
  }
};
</script>